import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ViewLeadContext } from "../..";
import { commonType } from "../../..";
import DataNotFound from "../../../../../../components/Data Not Found";
import Form from "../../../../../../components/View Lead Components/MenuData/Invoice Components/Form";
import useLoading from "../../../../../../hooks/useLoading";
import { getInvoice } from "../../../../../../lib/api functions/invoice/invoice";
import { invoiceStatussMap } from "../../../../../../utils/constants";
import { MainContext } from "../../../../../../utils/private_routes/PrivateRoutes";
import { ParamType } from "./type";

const ViewInvoice = () => {
  const { id } = useContext(ViewLeadContext);
  const { setting, companyId } = useContext(MainContext);
  const [commonData, setCommonData] = useState<commonType>({
    data: undefined,
    modal: false,
    check: "",
  });
  const [loading, showLoader, hideLoader] = useLoading();
  const [invoices, setInvoices] = useState<any>([]);
  const [totalResult, setTotalResult] = useState<number>(0);
  const [params, setParams] = useState<ParamType>({
    // page: 1,
    // per_page: 10,
    lead: id,
    company: companyId,
    isCancelled: false,
  });

  const fn = {
    openForm: (data: any) => {
      setCommonData({
        data: data ? data : undefined,
        modal: true,
        check: "invoice_menu",
      });
      document.body.style.overflow = "hidden";
    },
    getInvoices: async (params?: ParamType) => {
      showLoader();
      const res = await getInvoice(params);
      if (res) {
        setInvoices(res.data.invoices);
        setTotalResult(res.data.total);
        hideLoader();
      }
    },
  };

  useEffect(() => {
    fn.getInvoices(params);
  }, []);

  return (
    <>
      <div>
        <div className="viewlead_content_header d-flex justify-content-between">
          <p className="m-0 font14x500 textColor3">Invoices</p>
          <button
            className="btn font12x500 buttonOne shadow-none"
            onClick={() => fn.openForm(null)}
          >
            <img src="/Assets/Svg/plusIcon.svg" alt="icon" className="me-2" />
            Add New Invoice
          </button>
        </div>

        {loading ? (
          <Skeleton height="190px" borderRadius="8px" />
        ) : (
          <div className="menu_content_wrapper">
            {/* table */}
            {invoices?.length !== 0 ? (
              <div className="entry_table_wrapper">
                <div className="table_wrapper">
                  <table className="table">
                    <thead className="table_head_small">
                      <tr className="font12x500 textColor3">
                        <th scope="col">Invoice Date</th>
                        <th scope="col">Invoice no</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Due date</th>
                        <th scope="col">Status</th>
                        {/* <th scope="col">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {invoices?.map((invoice: any, i: number) => {
                        return (
                          <tr key={i} className="font12x400">
                            <td>
                              {moment(invoice?.date).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>{invoice?.invoiceNumber}</td>
                            <td>{`₹ ${invoice?.calculation?.total}`}</td>
                            <td>
                              {moment(invoice?.dueDate).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>{invoiceStatussMap.get(invoice?.status)}</td>
                            {/* <td>
                              <p className="mb-0 font10x400 textColor2 cursor_pointer">
                                Download
                              </p>
                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <DataNotFound />
            )}
          </div>
        )}
      </div>

      {/* form modal */}
      {commonData?.modal && commonData?.check === "invoice_menu" && (
        <Form
          state={commonData}
          setState={setCommonData}
          apiCall={fn.getInvoices}
          params={params}
        />
      )}
    </>
  );
};

export default ViewInvoice;
